import { organisationConstants } from '../../_constants/organisation.constants';

const initialState = { delOrgLoading : true, delOrgMessage: '', delOrgError: false};

export function deleteOrgState(state = initialState, action) {
    switch (action.type) {
        case organisationConstants.REQUEST_DEL_ORG:
            return {
                delOrgLoading: true,
                delOrgMessage: '',
                delOrgError: false
            };
        case organisationConstants.RESPONSE_DEL_ORG:
            return {
                delOrgLoading: false,
                delOrgMessage: action.delOrgs,
                delOrgError: false
            }
        case organisationConstants.ERROR_DEL_ORG:
            return {
                delOrgLoading: false,
                delOrgMessage: '',
                delOrgError: true
            }
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/deleteOrganisation.reducer.js